import { useEffect, useState } from "react";

export function useCountry(defaultCountry = "US") {
  const [country, setCountry] = useState(defaultCountry);

  useEffect(() => {
    try {
      const match = document.cookie.match(/(?:^|;\s*)country=([^;]+)/);
      if (match && match[1]) {
        setCountry(decodeURIComponent(match[1]));
      }
    } catch (err) {
      console.error("useCountry: failed to read cookie", err);
    }
  }, []);

  return country;
}
